import { render, staticRenderFns } from "./ScreenLaudoMorfologica.vue?vue&type=template&id=9d0cfbde&lang=true&"
import script from "./ScreenLaudoMorfologica.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoMorfologica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports